import React from "react";
import { ActionWithRulesAndAddersProps } from "react-querybuilder";
import { IconButton } from "@chakra-ui/react";
import { CloseIcon } from "modules/icons";
import colors from "app/colors";

const QueryRemoveRuleAction: React.FC<ActionWithRulesAndAddersProps> = ({
  handleOnClick,
  className,
}) => (
  <IconButton
    aria-label="remove"
    className={className}
    onClick={handleOnClick}
    color={colors.blue}
    fontSize={12}
    fontWeight={600}
    icon={<CloseIcon boxSize={4} fill={colors.gray40} />}
    variant="hover"
    size="xxs"
  />
);

export default QueryRemoveRuleAction;
